import styled from 'styled-components'
import { H1, H2 } from 'syf-component-library/ui/typography'

export const OfferSection = styled.div`
  height: 100%;
`
export const OfferWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ theme }): string => theme.offerSection.background};
  color: ${({ theme }): string => theme.offerSection.text};
  padding: 30px 20px;
  & hr {
    border-top: 3px solid ${({ theme }): string => theme.offerSection.border};
  }
`

export const List = styled.ul`
  list-style-type: disc;
  margin: 0;
  li {
    line-height: 2;
  }
  padding: 0 20px;
  font-size: 14px;
`

export const Header = styled(H1)`
  font-size: 16px;
  margin: 8px 0 0;
`

export const SubHeader = styled(H2)`
  font-size: 21px;
  margin: 8px 0 0;
  width: 64%;
  padding: 5px 0px 12px 0;
`
